"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.kansaTargetRegisterReducer = exports.kansaTargetRegisterActions = exports.TYPES = exports.PERMISSION_KEY = exports.INIT_STATE = exports.CONTENTS = void 0;
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'TargetRegister';

/**
 * アクションタイプ
 */
const TYPES = exports.TYPES = {
  SET_ENTRY: PREFIX + 'SetEntry',
  SET_ENTRIES: PREFIX + 'SetEntries',
  SET_CONTENT: PREFIX + 'SetContent',
  SET_PERMISSION: PREFIX + 'SetPermission',
  CLEAR: PREFIX + 'Clear'
};

/**
 * コンテンツタイプ
 */
const CONTENTS = exports.CONTENTS = {
  ENTRY: 'entry',
  RESULT: 'result'
};
// 利用許可属性
const PERMISSION_KEY = exports.PERMISSION_KEY = {
  EDIT: 'edit'
};

/**
 * 初期State
 */
const INIT_STATE = exports.INIT_STATE = {
  permission: {
    [PERMISSION_KEY.EDIT]: false
  },
  dispContent: CONTENTS.ENTRY,
  entries: {
    kansaTgtNendo: 0,
    kansaTgtJigyoId: '',
    kansaTgtNendoNm: '',
    kansaThemeNm: '',
    kansaTgtJigyoNm: '',
    kansabumonKaishaCd: '',
    kansabumonSoshikiCd: '',
    kansabumonNm: '',
    hikokaiFlg: false,
    tantososhiki: {},
    tantososhikiList: []
  }
};

/**
 * アクション定義
 */
const kansaTargetRegisterActions = exports.kansaTargetRegisterActions = (0, _reduxActions.createActions)({
  [TYPES.SET_ENTRY]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_ENTRIES]: function () {
    return {
      data: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_CONTENT]: function () {
    return {
      content: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_PERMISSION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      flg: arguments.length <= 1 ? undefined : arguments[1]
    };
  }
}, TYPES.CLEAR);

/**
 * Reducer定義
 */
const kansaTargetRegisterReducer = exports.kansaTargetRegisterReducer = (0, _reduxActions.handleActions)({
  [TYPES.SET_ENTRY]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        [action.payload.key]: action.payload.value
      })
    });
  },
  [TYPES.SET_ENTRIES]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: action.payload.data
    });
  },
  [TYPES.SET_CONTENT]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: action.payload.content
    });
  },
  [TYPES.SET_PERMISSION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    permission: {
      [action.payload.key]: action.payload.flg
    }
  }),
  [TYPES.CLEAR]: () => {
    return _objectSpread(_objectSpread({}, INIT_STATE), {}, {
      entries: {
        kansaTgtNendo: 0,
        kansaTgtJigyoId: '',
        kansaTgtNendoNm: '',
        kansaThemeNm: '',
        kansaTgtJigyoNm: '',
        kansabumonKaishaCd: '',
        kansabumonSoshikiCd: '',
        kansabumonNm: '',
        hikokaiFlg: false,
        tantososhiki: {},
        tantososhikiList: []
      }
    });
  }
}, INIT_STATE);